<template>
    <div class="excel-up">
        <input v-if="" id="excel-upload-input" ref="excel-upload-input" type="file" accept=".xlsx, .xls"
            @change="handleClick">
        <!-- <el-button v-show="!loading" style="margin-left:16px;" size="mini" @click="handleUpload">
           <span>导入Excel</span>
      </el-button>
      <el-button v-show="loading" size="mini">
            <span>导入中</span>
            <span class="el-icon-loading"></span>
      </el-button> -->
    </div>
</template>

<script>
import { subExcel, exPersons, excelErrors } from '@/api/pressRole/pressRole';
import { ssExcel, pExcel } from '@/api/pressRole/pressSuccessive';
// import { tb2Edit,tb2Predata } from '@/api/edits';
// import { deleteAll6 } from '@/api/rowsDelete';
export default {
    props: ['pressType', 'pressId', 'mtId', "excelCode"],
    data() {
        return {
            loading: false,
            numData: {

            },
            excelData: {
                header: null,
                results: null,
            },

            map401: {}
        }
    },
    methods: {

        handleUpload(dat) {
            document.getElementById('excel-upload-input').click();
            if (this.excelCode == '401') {
                this.map401 = dat;
            }
        },
        errorHandler: function (code, loading) {
            var vm = this;

            excelErrors({ num: code }).then(response => {
                var errorDatas = [];
                for (var i in response.exportLogs) {
                    if (response.exportLogs[i].errMsg) {
                        errorDatas.push(response.exportLogs[i]);
                    }
                }
                var successSure = true;
                for (var i in errorDatas) {
                    if (errorDatas[i].errMsg) {
                        successSure = false;
                        break;
                    }
                }

                setTimeout(() => {
                    loading.close();
                    if (successSure) {
                        vm.$alert('导入成功！', '提示', {
                            confirmButtonText: '确定',
                            type: 'success',
                            callback: function (action) {
                                vm.$emit('t-frash');
                            }
                        });
                    } else {
                        vm.$message.error('导入失败！');
                        vm.$emit('excel-errors', errorDatas);
                        vm.$emit('t-frash');

                    }
                }, 600);

            }).catch(error => {
                loading.close();
            })
        },

        specialUpex: function (code, data, loading, id) {
            // specialUpex:function(code,data,errors,loading){
            var vm = this;
            /*
             *  多线程
             */

            var postArr = [];

            for (var i = 0; i < 2000; i++) {
                if (data.length > 2000) {
                    postArr.push(new Promise((resolve, reject) => {
                        var post = {};
                        post.iMaterial05s = data.splice(0, 2000);
                        setTimeout(function () {
                            excelIn5(post).then(response => {
                                ExcelErrors({ code: response.payload.num }).then(response => {
                                    var errorDatas = [];
                                    for (var t in response.payload.exportLogs) {
                                        if (response.payload.exportLogs[t].errMsg) {
                                            errorDatas.push(response.payload.exportLogs[t]);
                                        }
                                    };
                                    resolve(errorDatas);
                                }).catch(error => {
                                    reject(error);
                                })
                            }).catch(error => {
                                reject(error);
                            })
                        }, i * 2000);
                    }));
                } else {
                    postArr.push(new Promise((resolve, reject) => {
                        var post = {};
                        post.iMaterial05s = data;
                        excelIn5(post).then(response => {
                            ExcelErrors({ code: response.payload.num }).then(response => {
                                var errorDatas = [];
                                for (var t in response.payload.exportLogs) {
                                    if (response.payload.exportLogs[t].errMsg) {
                                        errorDatas.push(response.payload.exportLogs[t]);
                                    }
                                };
                                resolve(errorDatas);
                            }).catch(error => {
                                reject(error);
                            })
                        }).catch(error => {
                            reject(error);
                        })
                    }));

                    break;
                }
            }

            Promise.all(postArr).then(result => {

                var allErrors = [];
                for (var i = 0; i < result.length; i++) {
                    allErrors.push(...result[i]);
                };

                var successSure = true;
                for (var i in allErrors) {
                    if (allErrors[i].errMsg) {
                        successSure = false;
                        break;
                    }
                }

                setTimeout(() => {
                    loading.close();
                    if (successSure) {
                        vm.$alert('导入成功！', '提示', {
                            confirmButtonText: '确定',
                            type: 'success',
                            callback: function (action) {
                                vm.$emit('t-frash');
                            }
                        });
                    } else {
                        var dataIN = {};
                        dataIN.organizationMaterialId = id;
                        deleteAll6(dataIN).then(response => {
                            vm.$emit('t-frash');
                        });
                        vm.$message.error('导入失败！');
                        vm.$emit('excel-errors', allErrors);

                    }
                }, 600);

            }).catch(error => {
                loading.close();
                var dataIN = {};
                dataIN.organizationMaterialId = id;
                deleteAll6(dataIN).then(response => {
                    vm.$emit('t-frash');
                });
            })

        },

        errorClean: function () {
            var dataIN = {};
            dataIN.organizationMaterialId = this.orgid;
            deleteAll6(dataIN);
        },

        handleClick(e) {

            var vm = this;
            var files = e.target.files;
            var fileReader = new FileReader();

            const loading = vm.$loading({
                lock: true,
                text: '导入中，请耐心等候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            if (!FileReader.prototype.readAsBinaryString) {
                FileReader.prototype.readAsBinaryString = function (fileData) {
                    var data = "";
                    var pt = this;
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        var bytes = new Uint8Array(reader.result);
                        var length = bytes.byteLength;
                        for (var i = 0; i < length; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        dataRead(data);

                        //pt.result  - readonly so assign binary
                    }
                    reader.readAsArrayBuffer(fileData);

                }
            } else {
                fileReader.onload = function (ev) {
                    var data = ev.target.result;
                    dataRead(data);
                    document.getElementById('excel-upload-input').value = '';
                };
                // 以二进制方式打开文件
            }

            fileReader.readAsBinaryString(files[0]);
            // console.log(e.target.files)

            function dataRead(data) {
                /*try {
                    var workbook = XLSX.read(data, {
                            type: 'binary'
                        }); // 以二进制流方式读取得到整份excel表格对象
                    var persons = []; // 存储获取到的数据
                } catch (e) {
                    this.$message({
                      type: 'error',
                      message: '文件类型不正确！'
                    });
                    return;
                }*/

                // console.log(data)

                var workbook = XLSX.read(data, {
                    type: 'binary'
                }); // 以二进制流方式读取得到整份excel表格对象
                var persons = []; // 存储获取到的数据

                // 表格的表格范围，可用于判断表头是否数量是否正确
                var fromTo = '';
                // 遍历每张表读取


                for (var sheet in workbook.Sheets) {
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        fromTo = workbook.Sheets[sheet]['!ref'];
                        persons = persons.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        break; // 如果只取第一张表，就取消注释这行
                    }
                }

                function dateFormate(time) {
                    let newDate = new Date(time);
                    let y = newDate.getFullYear();
                    let m = newDate.getMonth() + 1;
                    let d = newDate.getDate();

                    if (m < 10) {
                        m = '0' + m;
                    }

                    if (d < 10) {
                        d = '0' + d;
                    }

                    return y + '-' + m + '-' + d;
                };

                // console.log(this.pressId);

                if (persons.length > 0) {
                    persons.shift();
                    if (vm.excelCode == '301') {
                        for (let item of persons) {
                            item.publishMaterialId = vm.$route.query.mtId;
                            item.publishId = vm.$route.query.pressId;
                            item.publishingTime = dateFormate(item.publishingTime);
                        }
                        subExcel({
                            data: persons,
                            // ppublicationList: persons,
                            type: vm.pressType,
                            // 身份验证要用
                            publishMaterialId: vm.$route.query.mtId
                        }).then(response => {
                            vm.errorHandler(response.num, loading);
                        }).catch(error => function () {
                            loading.close();
                        });
                    } else if (vm.excelCode == '401') {
                        for (let item of persons) {
                            item.publishId = vm.pressId[0].psId;
                            item.publishMaterialId = vm.map401[item.materialCode];
                            item.approvalTime = dateFormate(item.approvalTime);
                        }
                        ssExcel({ plxdzPublicationList: persons }).then(response => {
                            vm.errorHandler(response.num, loading);
                        }).catch(error => function () {
                            loading.close();
                        });
                    } else if (vm.excelCode == '404') {

                        for (let item of persons) {
                            item.publishMaterialId = vm.$route.query.mtId;
                            item.publishId = vm.$route.query.pressId;
                            item.materialCode = vm.$route.query.mtcode;
                        }
                        console.log(persons);
                        pExcel({
                            importWorkerList: persons,
                            // 身份验证要用
                            publishMaterialId: vm.$route.query.mtId
                        }).then(response => {
                            vm.errorHandler(response.num, loading);
                        }).catch(error => function () {
                            loading.close();
                        });

                    } else if (vm.excelCode == '208') {
                        for (let item of persons) {
                            item.publishMaterialId = vm.$route.query.mtId;
                            item.publishId = vm.$route.query.pressId;
                            item.materialCode = vm.$route.query.mtcode;
                        }
                        exPersons({
                            // importWorkerList: persons,
                            data: persons,
                            type: vm.pressType,
                            // 身份验证要用
                            publishMaterialId: vm.$route.query.mtId
                        }).then(response => {
                            vm.errorHandler(response.num, loading);
                        }).catch(error => function () {
                            loading.close();
                        });

                    }
                } else {
                    setTimeout(() => {
                        loading.close();
                        vm.$alert('请检查数据后重新导入！', '导入失败', {
                            confirmButtonText: '确定',
                            callback: action => {
                                vm.$message({
                                    type: 'error',
                                });
                            }
                        });
                    }, 600);

                }

                vm.$emit("imported", persons);

                // console.log(persons);
            };

        },

        readerData(rawFile) {
            const workbook = XLSX.read(btoa(rawFile), { type: 'base64' })
        },

        upLoadFiles: function () {

        }

    },

    created: function () {
        // console.log(this.excelCode);
    }
}
</script>

<style lang="scss">
#excel-upload-input {
    display: none;
    z-index: -9999;
}

.excel-up {
    display: inline-block;

    #excel-upload-input {
        display: none;
        z-index: -9999;
    }

    .el-button {
        margin: 0px !important;
    }
}
</style>



// WEBPACK FOOTER //
// excel.vue?733db162